import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Col, Form, Row, Radio } from "antd";
import { formLayout, formRules } from '../../../../../utilities';
import WizardFormButtons from "../../../../ui/forms/WizardFormButtons";
/**
 * Page from the form wizard with additional property questions/options.
 */
@inject("context")
@observer
class PropertyOptionsInfo extends Component {
	static propTypes = {};

	render() {
		const { clientData } = this.props.service;
		const { isViewMode } = this.props.context.policiesService;
		return (
			<Form
				{...formLayout}
				onFinish={this.props.onFinish}
				colon={true}
				initialValues={{
					insurance_declaration: clientData.insurance_declaration,
				}}
			>
				<Row>
					<Col xs={8} offset={1}>
						<h4 className="my-5">Declarations</h4>
						<p>Have you ever:</p>
						<ul>
							<li>Been refused insurance?</li>
							<li>Had an insurance policy cancelled or declined?</li>
							<li>Had an insurer impose special terms?</li>
							<li>Been convicted of fraud, arson or theft?</li>
							<li>Been subject to bankrupcy proceedings?</li>
						</ul>

						<Form.Item
							name="insurance_declaration"
							label=""
							rules={[
								{
									required: true,
									message: "This field is required!",
								},
							]}
						>
							<Radio.Group disabled={isViewMode}>
								<Radio value={true}>Yes</Radio>
								<Radio value={false}>No</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col xs={24} className="d-flex">
						<WizardFormButtons tabs={this.props.tabs} />
					</Col>
				</Row>
			</Form>
		);
	}
}

export default PropertyOptionsInfo;
